module.exports = __webpack_public_path__ + "img/form_big_desktop.b99d26eb.svg";